import { RC_DURATION } from '@lambda/reebelo';
import settings, { priceFormater } from '@/settings';
import {
  benefitsList,
  reebeloCareSpecs,
  reebeloCareTitles,
  warrantyDisclaimers,
  warrantySlideOverTitles,
  warrantySliderOverAcceptCta,
  warrantyUpsellAcceptCta,
  warrantyUpsellContents,
  warrantyUpsellRejectCta,
  warrantyUpsellTitles,
} from './constants';
import { ProductWarrantyT } from './types';

export const generateReebeloCareTitle = () =>
  reebeloCareTitles[settings.store] ?? reebeloCareTitles.default;

export const generateReebeloCareSpecs = () =>
  reebeloCareSpecs[settings.store] ?? reebeloCareSpecs.default;

export const generateWarrantySlideOverTitle = () =>
  warrantySlideOverTitles[settings.store] ?? warrantySlideOverTitles.default;

export const generateWarrantySlideOverCta = (price?: number) => {
  const content =
    warrantySliderOverAcceptCta[settings.store] ??
    warrantySliderOverAcceptCta.default;

  if (price) return `${content} - ${priceFormater.long(price)}`;

  return content;
};

export const generateWarrantyBenefitsList = () =>
  benefitsList[settings.store] ?? benefitsList.default;

export const generateWarrantyUpsellTitle = () =>
  warrantyUpsellTitles[settings.store] ?? warrantyUpsellTitles.default;

export const generateWarrantyUpsellContent = (price?: number) => {
  const content =
    warrantyUpsellContents[settings.store] ?? warrantyUpsellContents.default;

  if (price) return `${content} for only ${priceFormater.long(price)}`;

  return content;
};

export const generateWarrantyUpsellCta = () => ({
  accept:
    warrantyUpsellAcceptCta[settings.store] ?? warrantyUpsellAcceptCta.default,
  reject:
    warrantyUpsellRejectCta[settings.store] ?? warrantyUpsellRejectCta.default,
});

export const generateWarrantyDisclaimer = () =>
  warrantyDisclaimers[settings.store] ?? warrantyDisclaimers.default;

export const generateProductWarrantySavings = (
  productWarranty: ProductWarrantyT,
) => {
  if (productWarranty[RC_DURATION['13_MONTH']] != null) {
    const costOf13Months = (productWarranty[13]?.price ?? 0) / 13;
    const costOf24Months = (productWarranty[24]?.price ?? 0) / 24;
    const savings = costOf13Months - costOf24Months;

    const percentageSavings = Math.ceil((savings / costOf13Months) * 100);

    if (percentageSavings >= 5) return percentageSavings;
  }

  return null;
};
